__turbopack_context__.v({
  "badge": "Badge-module-scss-module__5eRUcW__badge",
});
